/* Noms affichés dans le CRM : client d'une affaire, responsable. */
export default function dealNamesHandlers({ adminUsers, crmClients }) {
  function dealClientName(id) {
    return (crmClients.find((c) => c.id === id) || {}).nom || '—';
  }

  function ownerName(id) {
    const u = adminUsers.find((x) => x.id === id);
    return u ? u.nom || u.email : null;
  }

  return { dealClientName, ownerName };
}
